export const VOICE_LANG_PRIORITY: ReadonlyArray<string> = [
  'sr-Latn-RS',
  'sr-Cyrl-RS',
  'sr-RS',
  'sr',
  'hr-HR',
  'hr',
  'bs-BA',
  'bs',
  'sl-SI',
  'sl',
  'en-US',
  'en-GB',
  'en',
]

export function pickBestVoice(
  voices: ReadonlyArray<SpeechSynthesisVoice>,
  preferredName: string | null,
): SpeechSynthesisVoice | null {
  if (voices.length === 0) return null

  if (preferredName) {
    const explicit = voices.find((v) => v.name === preferredName)
    if (explicit) return explicit
  }

  for (const lang of VOICE_LANG_PRIORITY) {
    const exact = voices.find((v) => v.lang === lang)
    if (exact) return exact
    const prefix = voices.find((v) => v.lang.startsWith(`${lang}-`))
    if (prefix) return prefix
  }

  return voices[0] ?? null
}
